<!-- TODO: make this just a css class, not a component -->
<script>
  let {
    children,
    class: css_class,
    direction = 'column',
    ref = $bindable(),
    ...rest
  } = $props()
 </script>
 
 {#if children}
  <div 
    bind:this={ref} 
    class='scroll-indicator {direction} {css_class}' 
    {...rest}
  >
    {@render children()}
  </div>
 {/if}
 
 <style>
    .scroll-indicator {
      display: flex;   
      min-height: 0;
      min-width: 0;
      /* Shadow color logic:
      * - If --color-background is set: use it darkened by 10%
      * - Otherwise: use --color-default-background-100 without darkening */
      --shadow-color: var(--color-background, var(--color-default-background-100));
      --shadow-color-darkened: oklch(from var(--shadow-color) calc(l - 0.1) c h);
      --final-shadow-color: var(--color-background, var(--shadow-color-darkened), var(--color-default-background-100));
    }
 
    .scroll-indicator.row {
      flex-direction: row;
      overflow: auto; /** must allow scrolling in both directions */
      width: 100%;
      background:
        /* Shadow Cover LEFT */
        linear-gradient(
          to right,
          var(--color-background, var(--color-default-background)) 30%,
          transparent
        ) left center,
        
        /* Shadow Cover RIGHT */
        linear-gradient(
          to left,
          var(--color-background, var(--color-default-background)) 30%,
          transparent
        ) right center,
        
        /* Shadow LEFT */
        radial-gradient(
          farthest-side at 0 50%,
          var(--color-background, var(--color-default-background-100)),
          transparent
        ) left center,
        
        /* Shadow RIGHT */
        radial-gradient(
          farthest-side at 100% 50%,
          var(--color-background, var(--color-default-background-100)),
          transparent
        ) right center;
      background-repeat: no-repeat;
      background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
      background-attachment: local, local, scroll, scroll;
    }
 
    .scroll-indicator.column {
      overscroll-behavior: none;
      flex-direction: column;
      overflow-y: auto;
      height: 100%;
      background:
        /* Shadow Cover TOP */
        linear-gradient(
          var(--color-background, var(--color-default-background)) 30%,
          transparent
        ) center top,
        
        /* Shadow Cover BOTTOM */
        linear-gradient(
          transparent, 
          var(--color-background, var(--color-default-background)) 70%
        ) center bottom,
        
        /* Shadow TOP */
        radial-gradient(
          farthest-side at 50% 0,
          var(--final-shadow-color),
          transparent
        ) center top,
        
        /* Shadow BOTTOM */
        radial-gradient(
          farthest-side at 50% 100%,
          var(--final-shadow-color),
          transparent
        ) center bottom;
     
      background-repeat: no-repeat;
      background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
      background-attachment: local, local, scroll, scroll;
    }
 </style>